import React from 'react'
import Container from '@material-ui/core/Container'
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main, //'DarkSlateGray', //theme.palette.common.black,
    color: theme.palette.common.white,
    paddingLeft: 8,
    paddingRight: 8
  },
  body: {
    fontSize: 16,
    paddingLeft: 8,
    paddingRight: 8
  },
}))(TableCell);


function ApiLogsTable(props) {
  const {records, resources} = props.data;

  return (
    <Container>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell align='left'> Timestamp </StyledTableCell>
              <StyledTableCell align='left'> Resource </StyledTableCell>
              <StyledTableCell align='left'> Parameters </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(records || []).map((record, index) => (
              <TableRow key={record.timestamp + index}>
                <StyledTableCell>{new Date(record.timestamp*1000).toISOString()}</StyledTableCell>
                <StyledTableCell>{resources[record.resource]}</StyledTableCell>
                <StyledTableCell>{record.search}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default ApiLogsTable;